import { createSelector, createStructuredSelector } from 'reselect';

import * as Tables from 'state/tables';
import { StoreType } from '@tock/shared/utils/connect';
import { keyBy } from 'es-toolkit/compat';

export const tablesStateSelector = createStructuredSelector<StoreType, { tables: Tables.State }>({
  tables: (state: StoreType): Tables.State => state.tables,
});

export const tablesSelector = createSelector(
  tablesStateSelector,
  (state): Tables.Table[] => state.tables.data || []
);

export const tableIdToTableSelector = createSelector(
  tablesSelector,
  (tables: Tables.Table[]): Dictionary<Tables.Table> => {
    return keyBy(tables, 'id');
  }
);
